<template>
  <div class="roulette game-table" :id="'rl-' + tableId ">
    <div class="game-table-title">
      <div class="row">
        <div class="col-xs-7">
          <h4>
            <i class="fa fa fa-cubes"></i>
            <span class="kind">{{ $t('games.roulette') }}</span>
          </h4>
        </div>
        <div class="col-xs-5 game-info text-right">
          <span v-if="round > 0">
            {{ $t('messages.round') }} {{ gameInfo }}
          </span>
          <span v-else>{{ $t('messages.break') }}</span>
        </div>
      </div>
    </div>
    <div class="game-table-detail clearfix">
      <div class="game-table-preview roulette">
        <div class="freeze-record">
          <div class="box-record-wrap dragscroll">
            <div class="box-record-inner" :style="'min-width:' + autoWidth + 'px'" v-if="statistics.score.length">
              <div class="row-record first">
                <div class="col-record">
                  R
                </div>
                <div class="col-record" v-for="no in statistics.score" :key="no">
                  <span class="stat-cc-16" :class="'cc-' + whatIsTheColorClass(no)">{{ no }}</span>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record">
                  B
                </div>
                <div class="col-record" v-for="big in statistics.big" :key="big">
                  <i :class="'icon-ring-' + whatIsTheColorClass(big)" v-if="big"></i>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record">
                  S
                </div>
                <div class="col-record" v-for="small in statistics.small" :key="small">
                  <i :class="'icon-ring-' + whatIsTheColorClass(small)" v-if="small"></i>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record">
                  O
                </div>
                <div class="col-record" v-for="odd in statistics.odd" :key="odd">
                  <i :class="'icon-ring-' + whatIsTheColorClass(odd)" v-if="odd"></i>
                </div>
              </div>
              <div class="row-record">
                <div class="col-record">
                  E
                </div>
                <div class="col-record" v-for="even in statistics.even" :key="even">
                  <i :class="'icon-ring-' + whatIsTheColorClass(even)" v-if="even"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="game-table-img">
        <span class="game-kind">{{ title }}</span>
        <img :src="image" width="100" height="100" key="image" v-if="image">
        <img src="//placehold.it/100x100" key="image" v-else>
      </div>
    </div>
    <div class="game-table-sub clearfix">
      <div class="row">
        <div class="col-lg-6 col-xs-5">
          <span>
            {{ $t('messages.bettime', { time: duration }) }}
          </span>
        </div>
        <div class="col-lg-6 col-xs-7 pull-right">
          <!-- Waiting implement -->
        </div>
      </div>
    </div>
    <div class="game-table-bottom clearfix">
      <span class="info">
        <i class="fa fa-info-circle"></i> {{ $t('messages.limit', { limit: betLimit }) }} |
        <i class="fa fa-users"></i> {{ $t('messages.userOnline', { count: online }) }}
      </span>
      <a :href="route" class="btn btn-primary">{{ $t('messages.playNow') }}</a>
    </div>
  </div>
</template>
<script>
  import { mapColor } from '../../../roulette/helpers'
  import api from '../../../roulette/api'
  export default {
    name: 'game-roulette',
    props: {
      user: {
        required: true,
        type: Object
      },
      kind: {
        required: true,
        type: String
      },
      tableId: {
        required: true,
        type: [Number, String]
      }
    },
    data () {
      return {
        config: {},
        stats: {},
        statistics: {
          score: []
        },
        channels: {
          personal: null,
          baccarat: null,
          sessions: null
        },
        betLimit: null
      }
    },
    mounted () {
      this.initialize()
    },
    methods: {
      initialize () {
        api.game.getGameConfigWithInformation(this.tableId,
          (response) => {
            this.config = _.omit(response.data, ['info.detail.statistic'])
            this.stats = _.get(response.data, 'info.detail.statistic', [])
          },
          (error) => {
            // Some api need to force user re-login, because jwt is not work.
            const status = _.get(error, 'response.status')
            if (status === 401) {
              location.href = '/logout'
              return
            }
          }
        )
      },
      whatIsTheColorClass (number) {
        return mapColor(number)
      }
    },
    computed: {
      autoWidth () {
        const length = this.statistics.score.length
        let width =  length * 28
        width = width > 205 ? width : 205
        if (length > 8) {
          setTimeout(() => {
            // $(`#rl-${this.tableId} .box-record-wrap`).scrollLeft(10000)
            $(`#rl-${this.tableId} .box-record-wrap`).animate({
              scrollLeft: width
            }, 1000)
          }, 1000)
        }
        return width
      },
      online () {
        return _.get(this.config, 'info.online')
      },
      duration () {
        return _.get(this.config, 'game.bet_duration')
      },
      gameInfo () {
        const shoe = _.padStart(this.shoe, 4, 0)
        const round =  _.padStart(this.round, 3, 0)
        return `${shoe}-${round}`
      },
      shoe () {
        return _.get(this.config, 'info.detail.shoe')
      },
      round () {
        return _.get(this.config, 'info.detail.round')
      },
      title () {
        return _.get(this.config, 'table.title')
      },
      route () {
        return '/games/live/roulette/' + this.tableId
      },
      image () {
        return _.get(this.config, 'dealer.image')
      }
    },
    watch: {
      'user': {
        handler: function (value, old) {
          const game = _.get(value, 'config.games.roulette.bet_limit.STRAIGHTUP')
          this.betLimit = `${game.min}-${this.$options.filters.number(game.max)}`
        },
        deep: false
      },
      'stats': {
        handler: function (value, old) {
          const statistics = value
          let localStats = {
            hot: [],
            cold: [],
            score: [],
            big: [],
            small: [],
            odd: [],
            even: [],
            count_big: 0,
            count_small: 0,
            count_odd: 0,
            count_even: 0,
            count_red: 0,
            count_black: 0
          }

          _.each(statistics, (stat) => {
            const score = stat.score
            localStats.hot = _.split(stat.hot, '-')
            localStats.cold = _.split(stat.cold, '-')
            localStats.score.push(score)
            if (score > 18) {
              localStats.big.push(score)
              localStats.small.push(null)
            } else {
              localStats.big.push(null)
              localStats.small.push(score)
            }
            if (score % 2 === 0) {
              localStats.even.push(score)
              localStats.odd.push(null)
            } else {
              localStats.even.push(null)
              localStats.odd.push(score)
            }

            if (score > 18) {
              localStats.count_big++
            } else {
              localStats.count_small++
            }
            if (stat.score % 2 === 0) {
              localStats.count_even++
            } else {
              localStats.count_odd++
            }
            const color = mapColor(score)
            if (color === 'red') {
              localStats.count_red++
            } else if (color === 'black') {
              localStats.count_black++
            }
          })
          this.statistics = localStats
        },
        deep: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/Roulette.vue